import { render, staticRenderFns } from "./select.vue?vue&type=template&id=acf4cada&scoped=true&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=acf4cada&lang=scss&scoped=true&"
import style1 from "./select.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf4cada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acf4cada')) {
      api.createRecord('acf4cada', component.options)
    } else {
      api.reload('acf4cada', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=acf4cada&scoped=true&", function () {
      api.rerender('acf4cada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/select/select.vue"
export default component.exports